import { useEffect, useRef } from 'react';

/**
 * Returns a ref which tracks whether the component is mounted or not.
 */
export function useIsMountedRef() {
  var isMountedRef = useRef(false);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  return isMountedRef;
}
export default useIsMountedRef;
//# sourceMappingURL=useIsMountedRef.js.map